// Spinner to show during async operations

import ClipLoader from 'react-spinners/ClipLoader';
import './Spinner.scss';

// `inline` takes it out of the overlay and lets it hold a place in the flow
// instead — for a block that is waiting for its own data rather than a page
// that is covered while it loads.
export default function Spinner({ show, inline, size = 80 }) {
  return (
    <div
      className={'spinner' + (inline ? ' inline' : '') + (show ? ' show' : '')}
    >
      <div className='spinner-inner'>
        <ClipLoader size={size} color='#3f90dc' loading={show} />
      </div>
    </div>
  );
}
